/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Deck_Upload_Attr_PlayerInputs */



/**
* | output |
* | --- |
* | "{name}'s deck" |
*
* @param {Deck_Upload_Attr_PlayerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_upload_attr_player = /** @type {((inputs: Deck_Upload_Attr_PlayerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Upload_Attr_PlayerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Deck de ${i?.name}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Deck de ${i?.name}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Deck de ${i?.name}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Deck di ${i?.name}`)
	return /** @type {LocalizedString} */ (`${i?.name}'s deck`)
});